import { credenciamento } from './modulos/credenciamento';
import { questionario } from './modulos/questionario';
import { forms } from './modulos/forms';
import { login } from './modulos/login';
import { logingerenciamento } from './modulos/logingerenciamento';
import { evento } from './modulos/evento';
import { endereco } from './modulos/endereco';
import { produtos } from './modulos/produtos';
import { email } from './modulos/email';
import { termos } from './modulos/termos';
import { pedidos } from './modulos/pedidos';
import { upload } from './modulos/upload';

export const types = {
    EVENTO: {...evento},
    CREDENCIAMENTO: {...credenciamento},
    QUESTIONARIO: {...questionario},
    FORMS: {...forms},
    LOGIN: {...login},
    LOGINGERENCIAMENTO: {...logingerenciamento},
    ENDERECO: {...endereco},    
    PRODUTOS: {...produtos},
    EMAIL: {...email},
    PENDINGTASK: 'PENDINGTASK',
    ERROR_NETWORK: 'ERROR_NETWORK',
    AUTHAPICIDTECH: 'AUTHAPICIDTECH',
    PESQUISA_TRADUCAO: 'PESQUISA_TRADUCAO',
    TRADUCAONOVOATUALIZA: 'TRADUCAONOVOATUALIZA',
    TERMOS: {...termos},
    PEDIDOS: {...pedidos},
    UPLOAD: {...upload}
}
